class ApplicantsController implements ng.IComponentController {

    constructor() {
        'ngInject';
        // console.log('ApplicantsController');
    }
}

export const applicantsComponent : ng.IComponentOptions = {
    controller : ApplicantsController,
    template : require('./applicants.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/applicants/applicants.component.ts